import React, { useMemo } from 'react'
import ProgressBar from '.'

const styles = {
  position: 'fixed',
  left: '0',
  top: '0',
  zIndex: 999999999,
  width: '100%',
  height: '100%',
  background: 'rgba(0,0,0,0.4)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

export default props => {
  const open = !!props.open

  if (open) {
    return (
      <div className="progress-bar-modal" style={styles}>
        <ProgressBar {...props} />
      </div>
    )
  }

  return null
}
